export default __webpack_public_path__ + "static/logo2-dark-025e38b271b10a599fd4f5178e14f37e.png";